import { render, staticRenderFns } from "./TextInputArea.vue?vue&type=template&id=70698a70&scoped=true&"
import script from "./TextInputArea.vue?vue&type=script&lang=ts&"
export * from "./TextInputArea.vue?vue&type=script&lang=ts&"
import style0 from "./TextInputArea.vue?vue&type=style&index=0&id=70698a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70698a70",
  null
  
)

export default component.exports